// extracted by mini-css-extract-plugin
module.exports = {"slide":"productSlide_slide__27dE2","imageArea":"productSlide_imageArea__2AfUm","widthPriorityImage":"productSlide_widthPriorityImage__1T-im","active":"productSlide_active__2Cg4K"};